import {UserProps} from "../interfaces/UserProps";
import {Role} from "../models/Role";

export const isAdmin = (userProps?: UserProps) => {
    if (userProps?.userData?.user) {
        return userProps.userData.user.role >= Role.Admin;
    }
    return false;
}